import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallUpsell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14" {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.5 4.668h-.875c-.806 0-1.458.653-1.458 1.458v4.667c0 .805.652 1.458 1.458 1.458H9.04c.806 0 1.459-.653 1.459-1.458V9.335M7 5.542h2.333M8.167 6.708V4.375"
    />
    <rect
      width={9.333}
      height={7.583}
      x={3.5}
      y={1.75}
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      rx={2}
    />
  </svg>
);
export default SvgSmallUpsell;
